import { defineMessages } from "react-intl";

const messages = defineMessages({
    slackChannel: {
      id: 'IntegrationsSettings.SlackChannel',
      defaultMessage: 'Channel Name',
    },
    channelRequired: {
      id: 'IntegrationsSettings.SlackChannelRequired',
      defaultMessage: 'Channel name is required.',
    },
    surveysRequired: {
      id: 'IntegrationsSettings.SlackSurveysRequired',
      defaultMessage: 'Please select some surveys.',
    },
    channelFormat: {
      id: 'IntegrationsSettings.SlackChannelFormat',
      defaultMessage: 'Channel names can only contain lowercase letters, numbers, hyphens, and underscores, and must be 80 characters or less.',
    },
    surveys: {
      id: 'IntegrationsSettings.SlackSurveys',
      defaultMessage: 'Surveys',
    },
    condition: {
      id: 'IntegrationsSettings.SlackCondition',
      defaultMessage: 'Condition',
    },
    addRule: {
      id: 'IntegrationsSettings.SlackAddRule',
      defaultMessage: 'Add a new rule',
    },
    conditionAllAll: {
      id: 'IntegrationsSettings.ConditionAllAll',
      defaultMessage: 'All responses',
    },
    conditionCommentedAll: {
      id: 'IntegrationsSettings.ConditionCommentedAll',
      defaultMessage: 'Only responses with comments',
    },
    conditionAllPromoters: {
      id: 'IntegrationsSettings.ConditionAllPromoters',
      defaultMessage: 'All "Satisfied"',
    },
    conditionCommentedPromoters: {
      id: 'IntegrationsSettings.ConditionCommentedPromoters',
      defaultMessage: 'Only "Satisfied" with comments',
    },
    conditionAllPassives: {
      id: 'IntegrationsSettings.ConditionAllPassives',
      defaultMessage: 'All "Neutral"',
    },
    conditionCommentedPassives: {
      id: 'IntegrationsSettings.ConditionCommentedPassives',
      defaultMessage: 'Only "Neutral" with comments',
    },
    conditionAllDetractors: {
      id: 'IntegrationsSettings.ConditionAllDetractors',
      defaultMessage: 'All "Dissatisfied"',
    },
    conditionCommentedDetractors: {
      id: 'IntegrationsSettings.ConditionCommentedDetractors',
      defaultMessage: 'Only "Dissatisfied" with comments',
    },
    all: {
      id: 'IntegrationsSettings.All',
      defaultMessage: 'All',
    },
    edit: {
      id: 'IntegrationsSettings.Edit',
      defaultMessage: 'Edit',
    },
    remove: {
      id: 'IntegrationsSettings.Remove',
      defaultMessage: 'Remove',
    },
    cancel: {
      id: 'Confirm.Cancel',
      defaultMessage: 'Cancel',
    },
    save: {
      id: 'Confirm.Save',
      defaultMessage: 'Save',
    },
  });

  export default messages;